import { QUESTIONS } from "./questions";

export type Tendency =
  | "明显偏 P"
  | "比较偏 P"
  | "弹性区"
  | "比较偏 J"
  | "明显偏 J";

export function validateAnswers(value: unknown): value is number[] {
  return (
    Array.isArray(value) &&
    value.length === QUESTIONS.length &&
    value.every(
      (answer) => Number.isInteger(answer) && answer >= 0 && answer <= 4,
    )
  );
}

export function calculateScore(answers: readonly number[]): number {
  if (!validateAnswers(answers)) {
    throw new Error("Answers must contain exactly 16 integers from 0 to 4.");
  }

  const total = answers.reduce((sum, answer, index) => {
    const question = QUESTIONS[index];
    if (!question) {
      return sum;
    }
    const leftToRight = answer - 2;
    const jPoints = question.jSide === "right" ? leftToRight : -leftToRight;
    return sum + jPoints;
  }, 0);

  return Math.round((total / (QUESTIONS.length * 2)) * 100);
}

export function getTendency(score: number): Tendency {
  if (score <= -50) return "明显偏 P";
  if (score <= -20) return "比较偏 P";
  if (score < 20) return "弹性区";
  if (score < 50) return "比较偏 J";
  return "明显偏 J";
}

export function formatScore(score: number): string {
  return score > 0 ? `+${score}` : String(score);
}
